import ReservationHotel from './ReservationHotel';

export default ReservationHotel;
